/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Cell, Text, Theme, useTheme } from 'bold-ui'
import { Fragment, ReactElement } from 'react'

interface HistoricoMedicoesDetailTableRowProps {
  titulo: string
  hasItems: boolean
  children: ReactElement
}

export default function HistoricoMedicoesDetailTableRow(props: HistoricoMedicoesDetailTableRowProps) {
  const { titulo, hasItems, children } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    hasItems && (
      <Fragment>
        <Cell size={12} style={styles.padding}>
          <Text variant='h5' bold>
            {titulo}
          </Text>
        </Cell>
        {children}
      </Fragment>
    )
  )
}

const createStyles = (theme: Theme) => ({
  padding: css`
    padding-bottom: 0rem;
    &:not(:first-of-type) {
      border-top: 1px solid ${theme.pallete.gray.c80};
    }
  `,
})
